<ppl-icon
  [svgIcon]="icon"
  width="24px"
  height="24px"></ppl-icon>

<div class="identity">
  <div class="name">
    {{ session.app_label }}
  </div>

  <div class="date">
    {{ session.created | pplDateTime }}
  </div>
</div>

<button
  pplButton
  pplButton1
  pplButtonSmall
  type="button"
  i18n="@@Sign_Out"
  (click)="signOutClick.emit()">
  Sign Out
</button>
